import { useMutation, useQueryClient } from '@tanstack/react-query'
import { supabase } from '../lib/supabase'

// Snapshot rows captured before delete so undo can re-insert them with their
// original UUIDs. FKs that cascade-deleted (e.g. price_history) are NOT
// restored — undo recovers the items themselves, not their full history.

export function useBulkDeletePantryItems() {
  const qc = useQueryClient()

  return useMutation({
    mutationFn: async (input: { householdId: string; itemIds: string[] }) => {
      if (input.itemIds.length === 0) return { deleted: [] as any[] }

      const { data: snapshot, error: snapErr } = await supabase
        .from('pantry_items')
        .select('*')
        .eq('household_id', input.householdId)
        .in('id', input.itemIds)
      if (snapErr) throw snapErr

      const { error: delErr } = await supabase
        .from('pantry_items')
        .delete()
        .eq('household_id', input.householdId)
        .in('id', input.itemIds)
      if (delErr) throw delErr

      return { deleted: snapshot ?? [] }
    },
    onSuccess: (_, vars) => {
      qc.invalidateQueries({ queryKey: ['pantry-items', vars.householdId] })
      qc.invalidateQueries({ queryKey: ['home',         vars.householdId] })
    },
  })
}

export function useRestorePantryItems() {
  const qc = useQueryClient()

  return useMutation({
    mutationFn: async (input: { householdId: string; rows: any[] }) => {
      if (input.rows.length === 0) return
      const { error } = await supabase
        .from('pantry_items')
        .insert(input.rows)
      if (error) throw error
    },
    onSuccess: (_, vars) => {
      qc.invalidateQueries({ queryKey: ['pantry-items', vars.householdId] })
      qc.invalidateQueries({ queryKey: ['home',         vars.householdId] })
    },
  })
}
